import Text from 'presentation/components/text/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Button from 'presentation/components/button/index.js';
import Timer from 'presentation/components/timer/index.js';
import DateTime from 'presentation/components/date-time/index.js';
import EventFormatter from 'presentation/formatters/event/formatter.js';
import DateTimeFormatter from 'presentation/formatters/date-time/index.js';
import { DURATION } from 'presentation/formatters/date-time/types.js';
import EventSignpostingIcons from 'presentation/components/event-signposting-icons/index.js';

export default function EventTimingStatus(props) {
    const {
        mojitoTools: { config },
        eventItem,
        onClick,
        hasStreaming,
    } = props;
    return (
        <Button config={config.container} onClick={onClick}>
            {eventItem.details.inPlay ? <LiveContent {...props} /> : <UpcomingContent {...props} />}
            <EventSignpostingIcons
                hasStreaming={hasStreaming}
                isNeutralVenue={eventItem.neutral}
                hasBetBuilderMarket={eventItem.hasBetBuilderMarket}
                hasBoostedMarkets={
                    Boolean(eventItem.boostedMarketIds?.length) ||
                    Boolean(eventItem.boostedPreBuiltBetBuilderMarketIds?.length)
                }
                config={config.eventSignpostingIcons}
            />
        </Button>
    );
}

const LiveContent = props => {
    const {
        mojitoTools: { config, l10n, stringResolver, appContext },
        eventItem,
        hasClockDetails,
        inplayTime,
    } = props;
    const { details, sportId } = eventItem;

    const durationInMinutes = DateTimeFormatter.formatDuration(
        inplayTime,
        appContext.userSettings(),
        appContext.systemSettings().language,
        DURATION.MINUTE
    );
    const period =
        !config.hidePeriodForSport.includes(eventItem.sportId) &&
        EventFormatter.getDescription(sportId, details?.inplayDescription, l10n);
    const liveStatus = period || stringResolver.resolveString('$EVENT_TIMING_STATUS.LIVE');
    const showTimeInfo = hasClockDetails || inplayTime > 0;
    return (
        <FlexPane config={config.dateTimeContainer}>
            <Text config={config.liveText}>{liveStatus}</Text>
            {showTimeInfo && (
                <Text config={config.liveText}>
                    {hasClockDetails ? (
                        <Timer
                            config={config.inPlayTime}
                            time={inplayTime}
                            direction={details.clockDirection}
                            running={details.isClockRunning}
                        />
                    ) : (
                        durationInMinutes
                    )}
                </Text>
            )}
        </FlexPane>
    );
};

const UpcomingContent = props => {
    const {
        mojitoTools: { config },
        eventItem,
    } = props;
    const { startTime } = eventItem;
    return (
        <FlexPane config={config.dateTimeContainer}>
            <Text config={config.upcomingText}>
                <DateTime config={config.dateFormatter} dateTime={startTime} />
            </Text>
            {config.splitDateTime && (
                <Text config={config.upcomingText}>
                    <DateTime config={config.timeFormatter} dateTime={startTime} />
                </Text>
            )}
        </FlexPane>
    );
};
